import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Button } from '../../../../components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from '../../../../components/ui/tooltip';
import ConfirmActionModal from '../../../../components/ConfirmActionModal/ConfirmActionModal';

interface DeleteNodeButtonProps {
  onDelete: () => Promise<void>;
  deleteButtonRef?: React.RefObject<HTMLButtonElement>;
}

function DeleteNodeButton({
  onDelete,
  deleteButtonRef
}: DeleteNodeButtonProps): React.ReactElement {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const handleDeleteClick = () => {
    setModalOpen(true);
  };

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant='ghost'
            size='icon'
            aria-label='Delete block'
            ref={deleteButtonRef}
            onClick={handleDeleteClick}
            className='h-10 w-10 hover:bg-gray-200 flex items-center justify-center -mt-1 rounded-full'
          >
            <X className='h-5 w-5 text-gray-500' />
          </Button>
        </TooltipTrigger>
        <TooltipContent className='text-white'>Delete block</TooltipContent>
      </Tooltip>
      <ConfirmActionModal
        confirmationMessage='Are you sure you want to delete this block?'
        secondaryConfirmationMessage='All of the connected blocks will also be deleted.'
        action={onDelete}
        open={modalOpen}
        setOpen={setModalOpen}
        isDelete
      />
    </>
  );
}

export default DeleteNodeButton;
